<template>
  <div
    v-if="!$store.getters.getMobilePhoneActive"
    class="web_home_style"
    height="70vh"
    align-center
    justify-center>

  </div>
  <div v-else class="web_home_style_mobile" height="70vh" align-center justify-center>

  </div>
</template>

<script>
import Router from "vue-router";
import appConfig from "../../config/app_config";
import UserObject from "../objects/UserObject.js";
import * as dssRequest from "../api/dssRequest";
import { store } from "../store";
import BaseComponent from "./base/BaseComponent.vue";
import BaseObject from "../objects/BaseObject";

export default {
  name: 'UserConfirmation',
  mounted() {
    this.readUrlAndProceed();
  },
  data() {
    return {
      statusCheck: {},
      orderStatus: '',
      leadText: '',
      loading: true,
      functionName: '',
      queryObject: {},
    };
  },
  methods: {
    goTo(page) {
      // window.EventBus.showPage(page);
      this.$router.push({
        name: page,
        params: 'component',
      });
    },
    readUrlAndProceed() {
      this.statusCheck = {
        Order: true,
        Confirmation: true,
        Status: true,
      };
      this.queryObject.OrderId = this.$route.query.OrderID;
      this.queryObject.Email = this.$route.query.Email;
      const action = this.$route.query.action;
      this.functionName = '';
      let objectId = '';
      console.log("Benjamin this.$store.getters['auth/userName']", this.$store.getters['auth/userName']);

      if (this.$store.getters['auth/userName'] !== ''){
        objectId = this.$store.getters['auth/userName'];
        if (action === 'accept') this.functionName = 'confirmOrder';
        else if (action === 'reject') this.functionName = 'cancelOrder';
        else return;
      } else {
        objectId = this.$store.getters.getCurrentAccountId + '_UM';
        if (action === 'accept') this.functionName = 'confirmNoLogin';
        else if (action === 'reject') this.functionName = 'cancelNoLogin';
        else return;
      }
      const payload = this.queryObject;

      dssRequest.doRequest(
        (response) => {
          console.log("The call for " + this.functionName + " was successful", response);
          if (this.functionName === 'confirmOrder' || this.functionName === 'confirmNoLogin') {
            // Handle the case where the order is accepted by user
            if (
              response.data.hasOwnProperty('PaymentId')
              && response.data.hasOwnProperty('PaymentUrl')
            ) {
              this.$store.commit('setTripFormPaymentId', response.data.PaymentId);
              if (response.data.PaymentUrl !== '') {
                const path = response.data.PaymentUrl;
                window.location = path;
              } else {
                this.goTo('MainEventInfo');
                this.$store.commit('setWebStepId', 2);
              }
            } else {
              this.goTo('UserTripList');
            }
          } else if (this.functionName === 'cancelOrder' || this.functionName === 'cancelNoLogin') {
            // Handle the case where the order is cancelled by user
            this.goTo('Homepage');
          }
          setTimeout(() => {
            this.loading = false;
          }, 250);
        },
        (error) => {
          console.log("The call for " + this.functionName + " was not successful", error);
          setTimeout(() => {
            this.loading = false;
          }, 250);
        },
        this.functionName,
        objectId,
        payload,
        600000,
        false,
      );
    },
  },
};
</script>

<style scoped>
  .web_home_style {
    background-color: rgba(124, 158, 158, 0.9);
    width: auto;
    height: 100vh;
    /*padding: -24px !important;*/
    margin-top: 1.2em !important;
    margin-left: -3.4em;
    margin-right: -4em;
  }
  .web_home_style_mobile {
    width: auto;
    height: 100vh;
    /*padding: -24px !important;*/
    margin-top: 1.2em !important;
    margin-left: -3.4em;
    margin-right: -4em;
  }
</style>
